// extracted by mini-css-extract-plugin
module.exports = {"text-skeleton":"text-skeleton_text-skeleton__YJBS4","title":"text-skeleton_title__wzxyy","line":"text-skeleton_line__xdg41","not-justified":"text-skeleton_not-justified__eV9uz"};